export default "__VITE_ASSET__7Irscb09__"